// src/v3/ui/backtester/charts/monte-carlo.tsx

import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface MonteCarloBucket {
  range: string;
  count: number;
  percentile?: string;
}

export function MonteCarloChart({ data }: { data: MonteCarloBucket[] }) {
  if (data.length === 0) {
    return (
      <div className="flex h-64 items-center justify-center text-sm text-muted-foreground">
        No Monte Carlo data
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={data} margin={{ top: 8, right: 16, bottom: 8, left: 8 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis
          dataKey="range"
          tick={{ fontSize: 10 }}
          className="text-muted-foreground"
        />
        <YAxis tick={{ fontSize: 11 }} className="text-muted-foreground" />
        <Tooltip
          formatter={(v) => [String(v), "Frequency"]}
          contentStyle={{ fontSize: "12px" }}
        />
        <Bar
          dataKey="count"
          fill="hsl(222.2 47.4% 11.2%)"
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
